import { createContext, useContext } from 'react';
import { useSelector } from '@xstate/react';
import type { SupervisorActorRef } from '@/services/supervisorService';

// The type for our context is an Actor based on our machine definition.
export const SupervisorContext = createContext<SupervisorActorRef | null>(null);

// The provider component that will wrap our app.
export const SupervisorProvider = SupervisorContext.Provider;

/**
 * Custom hook to access the running Supervisor state machine actor.
 * It returns the current state, the send function, and the actor ref itself.
 */
export const useSupervisor = () => {
  const actor = useContext(SupervisorContext);

  if (!actor) {
    throw new Error('useSupervisor must be used within a SupervisorProvider');
  }

  const state = useSelector(actor, (snapshot) => snapshot);

  return { state, send: actor.send.bind(actor), actor };
};
